<svg [attr.class]="'icon icon-' + icon ">
  <use [attr.xlink:href]="'./assets/sprite/sprite.svg#' + icon"></use>
</svg>
